import {createFileRoute} from '@tanstack/react-router'
import ClashOfTeamsLiveView from '../../clash-of-teams/ClashOfTeamsLiveView'
import services from '../../services'
import {config} from '../../config/config'
import {humanizeSlug} from '../../utilities'

export const Route = createFileRoute('/live/clash-of-teams/$uid')({
    component: RouteComponent,
    // Fetch the clash server-side so the title/description render in the SSR HTML (SEO).
    loader: async ({params}) => {
        try {
            const data = await services.clashOfTeams.dashboard(params.uid)
            return {event: (data as any)?.clash || null}
        } catch {
            return {event: null}
        }
    },
    head: ({loaderData, params}) => {
        const e: any = (loaderData as any)?.event
        const name = e?.title || humanizeSlug(params.uid)
        const sport = e?.sport_type ? String(e.sport_type).replace(/_/g, ' ') : 'sports'
        const fmt = e?.match_format ? ` ${String(e.match_format).replace(/_/g, ' ')}` : ''
        const slug = e?.slug || params.uid
        return {
            meta: [
                {title: `${name} | Live Clash of Teams | ScorePal`},
                {name: 'description', content: `Follow ${name} live on ScorePal. Real-time ${sport}${fmt} Clash of Teams standings, weekly fixtures, scores, and team rankings.`},
            ],
            links: [{rel: 'canonical', href: `${config.publicUrl}/live/clash-of-teams/${slug}/`}],
        }
    },
})

function RouteComponent() {
    return <ClashOfTeamsLiveView />
}
